<template>
	<div>
		<div class="row">
			<div class="panel panel-primary">
			    <div class="panel-heading">
			    	<div class="row">
						<div class="col-xs-10 col-sm-9 col-md-6">
							<h3 class="panel-title">Relay Events</h3>
						</div>
						<div class="col-xs-2 col-sm-3 col-md-6">
							<div class="input-group pull-right">
								<button class="btn btn-sm btn-success" v-on:click="deselectEvent()" v-show="selectedEventIndex != null">View All Relay Events</button>
								<a :href="relay_sdif_url" class="btn btn-sm btn-success" v-show="selectedEventIndex == null">Download Relay Entry File</a>
							</div>
						</div>
					</div>
			    </div>
				<table class="table table-bordered table-striped table-condensed">
					<thead>
						<tr>
							<th>&nbsp;</th>
							<th>Event#</th>
							<th>Gender</th>
							<th>Event</th>
							<th>Age Groups</th>
							<th>Teams</th>
						</tr>
					</thead>
					<tbody>
						<tr class="eventRow" v-for="(event, index) in relayEvents" v-on:click="selectEvent(index)" v-show="selectedEventIndex == null || selectedEventIndex===index">
							<td class="row-actions">
								<button class="btn btn-success btn-sm" v-show="selectedEventIndex == null" @click.stop="selectEvent(index)"><span class="glyphicon glyphicon-zoom-in" aria-hidden="true"></span></button>
								<button class="btn btn-success btn-sm" v-show="selectedEventIndex===index" @click.stop="deselectEvent"><span class="glyphicon glyphicon-zoom-out" aria-hidden="true"></span></button>
							</td>
							<td>{{ event.event_number }}</td>
							<td>{{ event.gender }}</td>
							<td>{{ event.event }}</td>
							<td><span v-for="age_group in event.age_groups">{{ age_group.name }}&nbsp;</span></td>
							<td>
								<table class="table table-condensed table-bordered" style="margin-bottom: 0; background-color: transparent">
									<tbody>
										<tr v-for="relay_team in event.relay_teams">
											<td style="width: 0; padding-left: 8px; padding-right: 8px">
												<strong>{{ relay_team.team }}</strong>
											</td>
											<td>
												{{ relay_team.entry_time == '' ? 'NT' : relay_team.entry_time}}
											</td>
										</tr>
									</tbody>
								</table>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>


		<div class="row" v-show="selectedEventIndex != null">
			<div class="row">
				<div class="col-xs-12 col-sm-6">
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-sm-6">
					<div class="panel panel-default">
						<!-- Default panel contents -->
						<div class="panel-heading">
							<h3 class="panel-title">Teams</h3>
						</div>
						<div class="panel-body">
							<div class="form-inline">
								<div class="form-group">
									<label>
										Select Age Group
									</label>
									<select v-model="selectedAgeGroup" class="form-control">
										<option v-for="age_group in ageGroups" :value="age_group.id">{{ age_group.name }}</option>
									</select>
								</div>
								<div class="form-group">
									<button class="btn btn-primary" v-on:click="addTeam()">Add Team</button>
								</div>
							</div>
						</div>

						<table class="table table-bordered table-condensed">
							<thead>
								<tr>
									<th>&nbsp;</th>
									<th>Event</th>
									<th>Team</th>
									<th>Entry Time</th>
								</tr>
							</thead>
							<tbody>

								<tr v-for="(team, index) in relayTeams" @click.stop="selectTeam(index)" class="teamRow" v-bind:class="{ 'bg-info' : selectedTeam === team }">
									<td class="row-actions row-actions-2-btn">
										<button class="btn btn-danger btn-sm" v-on:click="deleteTeam(team.id)"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></button>
										<button class="btn btn-success btn-sm" v-show="selectedTeam !== team" @click.stop="selectTeam(index)"><span class="glyphicon glyphicon-zoom-in" aria-hidden="true"></span></button>
										<button class="btn btn-success btn-sm" v-show="selectedTeam === team" @click.stop="selectTeam(index)"><span class="glyphicon glyphicon-zoom-out" aria-hidden="true"></span></button>
									</td>
									<td>{{ team.gender }} {{ team.age_group }} {{ team.event }}</td>
									<td>{{ team.team }}</td>
									<td>
										<div class="input-group" v-show="selectedTeamIndex === index">
											<input @click.stop='' class="form-control" v-model="relayTeams[index].entry_time"/>
											<span class="input-group-btn">
												<button class="btn btn-success" v-on:click="updateTeam(index)">Update</button>
											</span>
										</div>
										<span v-show="selectedTeam !== team">
											{{ team.entry_time == '' ? 'NT' : team.entry_time }}
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6" v-show="selectedTeamIndex != null">
					<div class="panel panel-default">
						<!-- Default panel contents -->
						<div class="panel-heading"><h3 class="panel-title">Selected Team</h3></div>
						<table class="table table-condensed">
							<thead>
								<tr>
									<th>&nbsp;</th>
									<th>Name</th>
									<th>Stroke</th>
									<th>Time</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(teamMember, index) in teamMembers" v-on:click="">
									<td class="row-actions row-actions-3-btn">
										<button class="btn btn-danger btn-xs" v-on:click="deleteTeamMember(index, teamMember.id)"><span class="glyphicon glyphicon-minus" aria-hidden="true"></span></button>
										<button class="btn btn-info btn-xs" v-on:click="moveTeamMemberUp(index)"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span></button>
										<button class="btn btn-info btn-xs" v-on:click="moveTeamMemberDown(index)"><span class="glyphicon glyphicon-triangle-bottom" aria-hidden="true"></span></button>
									</td>
									<td>{{ teamMember.leg }}. {{ teamMember.name }}</td>
									<td>{{ relayLegStroke(teamMember.leg) }}</td>
									<td>{{ memberTimeForLeg(teamMember, 'SC') }}</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<th colspan="3" class="text-right">Total Time (excl. NT times)</th>
									<th>{{ relay_team_total_time }}</th>
								</tr>
							</tfoot>
						</table>
					</div>

					<div class="panel panel-default">
						<!-- Default panel contents -->
						<div class="panel-heading">
							<div class="row">
								<div class="col-xs-10 col-sm-9 col-md-6">
									<h3 class="panel-title">Available Team Members</h3>
								</div>
								<div class="col-xs-2 col-sm-3 col-md-6">
									<div class="input-group pull-right">
										<input type="checkbox" v-model="swimUp" v-on:change="loadCandidatesForSelectedTeam()" />&nbsp; Swim Up
									</div>
								</div>
							</div>
						</div>
						<table class="table table-condensed">
							<thead>
								<tr>
									<th>&nbsp;</th>
									<th>Name</th>
									<th v-for="legName in relayEventLegNames()">{{ legName }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(candidate, index) in availableCandidates" v-on:click="">
									<td class="row-actions ">
										<button class="btn btn-success btn-xs" v-on:click="addTeamMember(candidate)"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button>
									</td>
									<td>{{ index + 1 }}. {{ candidate.name }}</td>
									<td v-for="pb in memberTimesForAllLegs(candidate, 'SC')">{{ pb }}</td>
								</tr>
							</tbody>
						</table>

					</div>
				</div>
			</div>
		</div>

	</div>

</template>

<script>

import { DatePicker, Message, Icon, Tooltip, Loading } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);


export default {
	components: { DatePicker, Message, Tooltip, Icon, Loading },
	props: ['meet_id'],
	data: function () {
		return {
			meetId: this.meet_id,
			selectedEventIndex: null,
			selectedTeamIndex: null,
			selectedAgeGroup: null,
			selectedTeam: null,
			relayEvents: [],
			relayTeams: [],
			teamCandidates: [],
			teamMembers: [],
			availableCandidates: [],
			ageGroups: [],
			loading: false,
			swimUp: false
		}
	},
	computed: {
		relay_sdif_url: function() {
			return '/club/meet/' + this.meet_id + '/download_relay_sdif_file';
		},
		relay_team_total_time: function() {
			var time = 0;
			if (this.selectedTeam !== null) {
				for ( var i = 0; i < this.teamMembers.length; i++) {
					time = time + this.convertFormattedTimeToSeconds(this.memberTimeForLeg(this.teamMembers[i], 'SC'))
				}
			}
			return this.convertSecondsToFormattedTime(time);
		}
	},
	mounted() {
		console.log('RelayEntries component mounted.');
		this.getMeetEvents();
	},
	methods: {
		getMeetEvents() {
			console.log('getMeetEvents.');
			// this.loadingInstance = Loading.service({text: "Loading events... please wait"});
			axios.get('/api/v1/meet/' + this.meet_id + '/events?filters=individual_relay:Relay').then((response) => {
				// this.loadingInstance.close();
				console.log(response.data);
				this.relayEvents = response.data;
			}).catch((error) => {
				// this.loadingInstance.close();
				this.$message({message: 'There was a problem loading relay events.', type: 'error'});
			});
		},
		loadRelayTeamsForSelectedEvent() {
			console.log('loadRelayTeamsForSelectedEvent.');
			// this.loadingInstance = Loading.service({text: "Loading events... please wait"});
			axios.get('/api/v1/relay_teams?filters=meet_event_id:' + this.relayEvents[this.selectedEventIndex].id).then((response) => {
				// this.loadingInstance.close();
				console.log(response.data);
				this.relayTeams = response.data;
			}).catch((error) => {
				// this.loadingInstance.close();
				this.handleHTTPError(error);
				this.$message({message: 'There was a problem loading teams for this event.', type: 'error'});
			});
		},
		loadCandidatesForSelectedTeam() {
			console.log('loadCandidatesForSelectedTeam.');
			axios.get('/api/v1/relay_teams/' + this.relayTeams[this.selectedTeamIndex].id + '/candidates', {params: { swim_up: this.swimUp }}).then((response) => {
				// this.loadingInstance.close();
				console.log(response.data);
				this.teamCandidates = response.data;
				this.filterCandidates();
			}).catch((error) => {
				// this.loadingInstance.close();
				this.$message({message: 'There was a problem loading available members for this team.', type: 'error'});
			});
		},
		filterCandidates() {
			console.log('filterCandidates.');
			var includeCandidate;
			this.availableCandidates = [];
			for (var candidate of this.teamCandidates) {
				console.log(candidate);
				includeCandidate = true;
				for (var member of this.teamMembers) {
					if (member.id == candidate.id) {
						includeCandidate = false;
					}
				}
				if (includeCandidate == true) {
					this.availableCandidates.push(candidate);
				}
				console.log(this.availableCandidates);
			}
		},
		selectEvent(index) {
			console.log('selectEvent.');
			console.log('Event Id ' + this.relayEvents[index].id + ' selected');
			if (this.selectedEventIndex == index) {
				this.selectedEventIndex = null;
				this.relayTeams = [];
			}
			else {
				this.selectedEventIndex = index;
				this.loadRelayTeamsForSelectedEvent();
				this.ageGroups = this.relayEvents[index].age_groups;
			}
		},
		deselectEvent() {
			console.log('deselectEvent.');
			this.selectedEventIndex = null;
			this.relayTeams = [];
		},
		addTeam() {
			console.log('addTeam called');
			// this.loadingInstance = Loading.service({text: "Loading events... please wait"});
			axios.post('/api/v1/relay_teams', {
				meet_event_id: this.relayEvents[this.selectedEventIndex].id,
				age_group_id: this.selectedAgeGroup
			}).then((response) => {
				// this.loadingInstance.close();
				console.log(response.data);
				this.loadRelayTeamsForSelectedEvent();
			}).catch((error) => {
				if (error.response.data.errors) {
					// We use fat arrow functions instead of function() because using fat arrows means we have access to "this"
					_.forOwn(error.response.data.errors, (errors, field_name) => {
						_.each(errors, (value, key) => {
							this.$message({message: value, type: 'error'});
							// console.log('Error: ' + value);
							// console.log('Field: ' + field_name);
						});
					});
				}
				else {
					this.$message({message: 'There was a problem adding a team for this event.', type: 'error'});
				}
			});
		},
		deleteTeam(id) {
			console.log('deleteTeam called');
			// this.loadingInstance = Loading.service({text: "Loading events... please wait"});
			axios.delete('/api/v1/relay_teams/' + id).then((response) => {
				// this.loadingInstance.close();
				console.log(response.data);
				this.loadRelayTeamsForSelectedEvent();
			}).catch((error) => {
				// this.loadingInstance.close();
				this.$message({message: 'There was a problem deleting the team.', type: 'error'});
			});
		},
		selectTeam(index) {
			console.log('selectTeam.');
			console.log('Team Id ' + this.relayTeams[index].id + ' selected');
			if (this.selectedTeamIndex == index) {
				this.selectedTeamIndex = null;
				this.selectedTeam = null;
				this.teamMembers = [];
			}
			else {
				this.selectedTeamIndex = index;
				this.selectedTeam = this.relayTeams[index];
				this.teamMembers = this.relayTeams[index].members;
				this.loadCandidatesForSelectedTeam();
			}
		},
		deleteTeamMember(index, id) {
			console.log('deleteTeamMember.');
			// this.teamMembers.splice(index, 1);
			this.relayTeams[this.selectedTeamIndex].members.splice(index, 1);
			this.filterCandidates();
			// this.loadingInstance = Loading.service({text: "Loading events... please wait"});
			this.updateTeam(this.selectedTeamIndex);
			// axios.delete('/api/v1/relay_teams/' + this.relayTeams[this.selectedTeamIndex].id + '/members/' + id).then((response) => {
			// 	// this.loadingInstance.close();
			// 	console.log(response.data);
			// 	this.loadRelayTeamsForSelectedEvent();
			// }).catch((error) => {
			// 	// this.loadingInstance.close();
			// 	this.$message({message: 'There was a problem removing the member from the team.', type: 'error'});
			// });
		},
		addTeamMember(candidate) {
			console.log('addTeamMember.');
			var lastTeamMember;
			var leg = 1;
			// if (this.teamMembers.length > 0) {
			if (this.relayTeams[this.selectedTeamIndex].members.length > 0) {
				// lastTeamMember = this.teamMembers[this.teamMembers.length - 1];
				lastTeamMember = this.relayTeams[this.selectedTeamIndex].members[this.relayTeams[this.selectedTeamIndex].members.length - 1];
				leg = lastTeamMember.leg + 1;
			}
			// this.teamMembers.push({id: candidate.id, leg: leg, name: candidate.name});
			this.relayTeams[this.selectedTeamIndex].members.push({id: candidate.id, leg: leg, name: candidate.name, pbs: candidate.pbs});
			this.filterCandidates();
			this.updateTeam(this.selectedTeamIndex);

			// axios.post('/api/v1/relay_teams/' + this.relayTeams[this.selectedTeamIndex].id + '/members/' + candidate.id, {
			// 	order: leg,
			// }).then((response) => {
			// 	// this.loadingInstance.close();
			// 	console.log(response.data);
			// 	this.$message({message: 'The team entry was updated successfully.', type: 'success'});
			// 	this.loadRelayTeamsForSelectedEvent();
			// }).catch((error) => {
			// 	// this.loadingInstance.close();
			// 	this.$message({message: 'There was a problem adding the member to the team.', type: 'error'});
			// });
		},
		updateTeam(teamIndex) {
			console.log('updateTeam.');
			console.log('teamIndex: ', teamIndex)
			
			axios.put('/api/v1/relay_teams/' + this.relayTeams[this.selectedTeamIndex].id, {
				team: this.relayTeams[this.selectedTeamIndex],
			}).then((response) => {
				// this.loadingInstance.close();
				console.log(response.data);
				this.$message({message: 'The team entry was updated successfully.', type: 'success'});
				// this.loadRelayTeamsForSelectedEvent(); // TODO Remove

				// Every time we make a change to the team we need to sync up the teamMembers array
				this.syncTeamMembers();
				this.getMeetEvents();

			}).catch((error) => {
				// this.loadingInstance.close();
				this.handleHTTPError(error);
				this.$message({message: 'There was a problem updating the team.', type: 'error'});
			});
		},
		moveTeamMemberUp(index, id) {
			console.log('moveTeamMemberUp.');
			if (index > 0) {
				this.relayTeams[this.selectedTeamIndex].members[index - 1] = this.relayTeams[this.selectedTeamIndex].members.splice(index, 1, this.relayTeams[this.selectedTeamIndex].members[index-1])[0];
				this.renumberTeamMembers(this.selectedTeamIndex);
				this.updateTeam();
			}
		},
		moveTeamMemberDown(index, id) {
			console.log('moveTeamMemberDown.');
			console.log(index);
			console.log(this.relayTeams[this.selectedTeamIndex].members.length);
			if (index < (this.relayTeams[this.selectedTeamIndex].members.length - 1)) {
				this.relayTeams[this.selectedTeamIndex].members[index + 1] = this.relayTeams[this.selectedTeamIndex].members.splice(index, 1, this.relayTeams[this.selectedTeamIndex].members[index+1])[0];
				this.renumberTeamMembers(this.selectedTeamIndex);
				this.updateTeam();
			}
		},
		renumberTeamMembers(teamIndex) {
			console.log('renumberTeamMembers.');
			for (var i = 0; i < this.relayTeams[teamIndex].members.length; i++) {
				this.relayTeams[teamIndex].members[i].leg = i+1;
			}
		},
		syncTeamMembers() {
			console.log('syncTeamMembers.');
			if (this.selectedTeamIndex !== null) {
				this.teamMembers = this.relayTeams[this.	selectedTeamIndex].members;
			}
			else {
				this.teamMembers = [];
			}
		},
		updateTeamTimes() {
			console.log('updateTeamTimes.');
			for (var i = 0; i < this.relayTeams[teamIndex].members.length; i++) {
				// var stroke = this.relayEvents[selectedEventIndex].event_stroke == 'Freestyle Team' ? 'FC' : 'BC';
				// for 
				// this.relayTeams[teamIndex].members[i].leg = i+1;
			}
		},
		relayLegStroke(leg) {
			var strokes = ['Backstroke', 'Breaststroke', 'Butterfly', 'Freestyle'];
			if (this.selectedTeam.event_stroke === 'Freestyle Team') {
				return 'Freestyle';
			}
			return strokes[leg-1];
		},
		relayLegStrokeCode(leg) {
			var strokes = ['BC', 'BR', 'FL', 'FC'];
			if (this.selectedTeam.event_stroke === 'Freestyle Team') {
				return 'FC';
			}
			return strokes[leg-1];
		},
		memberTimeForLeg(teamMember, course) {
			console.log('memberTimeForLeg');
			console.log('Getting memberTimeForLeg ' + teamMember.name + ' course ' + course);

			var pb_event_code = this.selectedTeam.leg_length + this.relayLegStrokeCode(teamMember.leg);
			if (teamMember.pbs.sc) {
				for (var time of teamMember.pbs.sc) {
					if (time.event_code === pb_event_code && time.course === course) {
						if (course === 'SC') {
							return time.sc_time;
						}
						else {
							return time.lc_time;
						}
					}
				}
			}
			else {
				console.log('No PBs');
			}
			return 'NT';
		},
		memberTimesForAllLegs(member, course) {
			var pb_event_code;
			var leg_times = [];
			var hasTime = false;
			if (this.selectedTeam !== null) {
				for (var l = 1; l<=4; l++) {
					pb_event_code = this.selectedTeam.leg_length + this.relayLegStrokeCode(l);
					for (var time of member.pbs.sc) {
						if (hasTime === false && time.event_code === pb_event_code && time.course === course) {
							hasTime = true;
							if (course === 'SC') {
								leg_times.push(time.sc_time);
							}
							else {
								leg_times.push(time.lc_time);
							}
						}
					}
					if (hasTime === false) {
						leg_times.push('');
					}
					hasTime = false;
				}
			}
			return leg_times;
		},
		relayEventLegNames() {
			var leg_names = [];
			var pb_event_code;
			if (this.selectedTeam !== null) {
				for (var l = 1; l<=4; l++) {
					pb_event_code = this.selectedTeam.leg_length + this.relayLegStrokeCode(l);
					leg_names.push(pb_event_code);
				}
			}
			return leg_names;
		},
		convertFormattedTimeToSeconds(formatted_time) {
			console.log('convertFormattedTimeToSeconds');
			console.log(formatted_time);

			if (formatted_time == 'NT') {
				return 0;
			}

			var minutes = 0;
			var seconds = 0;
			var hundredths = 0;

			// Separate off the hundredths if provided
			var split1 = formatted_time.split('.');
			// If there were no hundredths then split1 = formatted_time
			var split2 = split1[0].split(':');

			if (split1.length == 2) {
				hundredths = split1[1];
			}
			else {
				hundredths = 0;
			}
			if (split2.length == 2) {
				minutes = split2[0];
				seconds = split2[1];
			}
			else if (split2.length == 1) {
				minutes = 0;
				seconds = split2[0];
			}
			else {
				minutes = 0;
				seconds = 0;
			}

			seconds = parseInt(seconds) + parseInt((minutes * 60)) + parseFloat((hundredths / 100));
			console.log(seconds);
			return seconds;

		},
		convertSecondsToFormattedTime(seconds) {
			console.log('convertSecondsToFormattedTime');
			console.log(seconds);
			var whole_seconds = Math.floor(seconds)
			var hundredths = parseInt((seconds - whole_seconds) * 100);
			var minutes = Math.floor(whole_seconds / 60);
			var seconds = whole_seconds % 60;
			var formatted_time = this.pad2zeroes(minutes) + ":" + this.pad2zeroes(seconds) + "." + this.pad2zeroes(hundredths);
			console.log(formatted_time);
			return formatted_time;
		},
		pad2zeroes(str)
		{
			return ("00" + str).slice(-2);
		},
		rpad2zeroes(str)
		{
			return (str + "00").slice(0,2);
		},
		handleHTTPError(error) {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					console.log(error.response.data); // Error message
					console.log(error.response.status);
					console.log(error.response.headers);
					this.$message({message: 'Error: ' + error.response.data, type: 'error'});
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
					this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
					this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
				}
				console.log(error.config);
		},
	}
}
</script>
<style scoped>
	tr.teamRow:hover, tr.eventRow:hover {
		cursor: pointer;
	}
</style>